import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { getVCardByUUID } from '../../services'
import { normalizeVCardUuid } from '../../utils/vcard-public'
import VCardPublicView from '../shared/VCardPublicView'

const VCardPreview = () => {
    const { uuid: routeUuid } = useParams<{ uuid: string }>()
    const uuid = normalizeVCardUuid(routeUuid)
    const navigate = useNavigate()

    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.VCARDS, 'preview', uuid],
        queryFn: async () => {
            try {
                return await getVCardByUUID(uuid)
            } catch (error) {
                toast.error('' + error)
            }
        },
        enabled: Boolean(uuid),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    if (!data?.result || !uuid) {
        return (
            <div className="w-full min-h-[50vh] flex items-center justify-center p-8 text-center text-gray-500">
                VCard not found
            </div>
        )
    }

    const vcardId = data.result.id

    return (
        <div className="w-full max-w-md mx-auto py-4 px-3">
            <VCardPublicView
                vcard={data.result}
                uuid={uuid}
                mode="preview"
                showEdit={Boolean(vcardId)}
                onEdit={() => {
                    if (vcardId) {
                        navigate(`/account/vcards/${vcardId}/edit`)
                    }
                }}
            />
        </div>
    )
}

export default VCardPreview
